module.exports = __webpack_public_path__ + "img/icon-tx.f00f53d4.png";